import React from 'react';
import AmountTag from 'pages/Dashboard/pages/Billing/AmountTag';
import {
  eobPaymentAmountClasses,
} from 'pages/Dashboard/pages/Billing/Payments/columns/eobsOverview';

type Props = {
  unallocated: number;
  className?: string;
};

export default function UnpostedAmountTag({ unallocated, className }: Props) {
  const tooltip = unallocated > 0 ? 'Remaining payment amount that has not been posted yet.' : undefined;

  return (
    <AmountTag
      value={unallocated}
      tooltip={tooltip}
      classes={{
        ...eobPaymentAmountClasses,
        root: className,
      }}
      useColors
    >
      {unallocated === 0 ? (<span className="text-gray-400">—</span>) : null}
    </AmountTag>
  );
}
